import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import UpIcon from "@material-ui/icons/ArrowUpward";
import DownIcon from "@material-ui/icons/ArrowDownward";
import BottomIcon from "@material-ui/icons/VerticalAlignBottom";
import TopIcon from "@material-ui/icons/VerticalAlignTop";

const ShowcaseItemActions = ({ onUp, onDown, onTop, onBottom, onDelete }) => {
  return (
    <Fragment>
      <IconButton aria-label="top" onClick={onTop}>
        <TopIcon />
      </IconButton>
      <IconButton aria-label="up" onClick={onUp}>
        <UpIcon />
      </IconButton>
      <IconButton aria-label="down" onClick={onDown}>
        <DownIcon />
      </IconButton>
      <IconButton aria-label="bottom" onClick={onBottom}>
        <BottomIcon />
      </IconButton>
      <IconButton aria-label="delete" onClick={onDelete}>
        <DeleteIcon />
      </IconButton>
    </Fragment>
  );
};

export default ShowcaseItemActions;
